// extracted by mini-css-extract-plugin
export default {"deleteModal":"DeleteModal_deleteModal__XN+RA","deleteModal__title":"DeleteModal_deleteModal__title__YpNXx","deleteModal__buttons":"DeleteModal_deleteModal__buttons__xv7ro"};